<template>
  <div>
    <h1>
      Payment Success!!!
    </h1>
    <div>
      <a href="/">Go to First Page</a>
    </div>
  </div>

</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  font-weight: normal;
  padding-top: 20px;
  padding-bottom: 30px;
}
p {
  color: #969696;
  margin-bottom: 0;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/Success/Success.vue